import image1 from "../../../ImageAssets/blog/blog1.jpg";
import image2 from "../../../ImageAssets/blog/blog2.jpg";
import image3 from "../../../ImageAssets/blog/blog3.jpg";
import image4 from "../../../ImageAssets/blogpage/4.jpg";
import image5 from "../../../ImageAssets/blogpage/5.jpg";
import image6 from "../../../ImageAssets/blogpage/6.jpg";
import image7 from "../../../ImageAssets/blogpage/7.jpg";
const BlogPageArray = () => {
  const myBlogs = [
    {
      id: 1,
      author: "admin",
      timestamp: "March 11,2022",
      title: "Yoga For Everyone in 2022",
      body: "Authoritatively disseminate multimedia based total linkage through market-driven methodolContinually transform integrated results vis-a-vis multidisciplinary manufacture Appropriately foster fullresearched innovation rather than backend supply. when an unknown printer took a galley.",
      image: image1,
    },
    {
      id: 2,
      author: "admin",
      timestamp: "April 22,2023",
      title: "Getting Back Into CrossFit After Vacation",
      body: "Authoritatively disseminate multimedia based total linkage through market-driven methodolContinually transform integrated results vis-a-vis multidisciplinary manufacture Appropriately foster fullresearched innovation rather than backend supply. when an unknown printer took a galley.",
      image: image2,
    },
    {
      id: 3,
      author: "admin",
      timestamp: "August 22,2023",
      title: "Meet Fitness Ambassador Grace",
      body: "Authoritatively disseminate multimedia based total linkage through market-driven methodolContinually transform integrated results vis-a-vis multidisciplinary manufacture Appropriately foster fullresearched innovation rather than backend supply. when an unknown printer took a galley.",
      image: image3,
    },
    {
      id: 4,
      author: "admin",
      timestamp: "September 22,2023",
      title: "The Best are European Materls Direct",
      body: "Authoritatively disseminate multimedia based total linkage through market-driven methodolContinually transform integrated results vis-a-vis multidisciplinary manufacture Appropriately foster fullresearched innovation rather than backend supply. when an unknown printer took a galley.",
      image: image4,
    },
    {
      id: 5,
      author: "admin",
      timestamp: "October 22,2023",
      title: "Give your Fitness a Boost with our Gym",
      body: "Authoritatively disseminate multimedia based total linkage through market-driven methodolContinually transform integrated results vis-a-vis multidisciplinary manufacture Appropriately foster fullresearched innovation rather than backend supply. when an unknown printer took a galley.",
      image: image5,
    },
    {
      id: 6,
      author: "admin",
      timestamp: "Novemeber 22,2023",
      title: "How to Get Fit Your Kids Moving Throughout The Summer",
      body: "Authoritatively disseminate multimedia based total linkage through market-driven methodolContinually transform integrated results vis-a-vis multidisciplinary manufacture Appropriately foster fullresearched innovation rather than backend supply. when an unknown printer took a galley.",
      image: image6,
    },
    {
      id: 7,
      author: "admin",
      timestamp: "December 22,2023",
      title: "Give your fitness a boost with our new gym challenge",
      body: "Authoritatively disseminate multimedia based total linkage through market-driven methodolContinually transform integrated results vis-a-vis multidisciplinary manufacture Appropriately foster fullresearched innovation rather than backend supply. when an unknown printer took a galley.",
      image: image7,
    },
  ];
  return myBlogs;
};

export default BlogPageArray;
